import React, {useEffect, useState} from 'react';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import Messages from '@core/scripts/components/messages';
import {Constants} from '../view-constants';
import '../../polyfill/urlsearchparams.es5';
import Icon from '@bonprix/pattern-library/templates/icon';

export default function TopCategories({topCategoriesParam, texts}) {
    const [topCategories, setTopCategories] = useState(topCategoriesParam);
    let firstRun = true;

    useEffect(() => {
        if (firstRun) {
            MessageBroker.publish(Messages.FOOTER.REINIT_ACCORDION);
            firstRun = false;
        }
        const subs = [
            MessageBroker.subscribe(Messages.ARTICLE_OVERVIEW.MODEL_UPDATE, (payload) => {
                update(payload);
            }),
        ];
        return () => {
            // on unmount
            subs.forEach((sub) => {
                MessageBroker.unsubscribe(sub);
            });
        };
    }, []);

    if (topCategories?.available) {
        return (
            <>
                <input
                    jsh-accordion__input=""
                    className="footer-accordion__input"
                    id="footer-accordion-group-5"
                    name="footer-accordion"
                    type="checkbox"
                />
                <label
                    className="footer-accordion__item-label -top-categories"
                    htmlFor="footer-accordion-group-5"
                    jsh-accordion__item-label=""
                >
                    <span className="footer-accordion__item-label-wrapper">
                        <span className="footer-accordion__item-label-title">{texts.footer_top_categories}</span>
                        <Icon className="footer-accordion__icon icon__touch-target" name="arrow-down" />
                    </span>
                </label>

                <div className="footer-accordion__item-content" jsh-accordion__item-content="">
                    <div className="top-categories__list">
                        <div className="top-categories__list-headline">{texts.footer_topcategories_headline}</div>

                        {topCategories.right.columns.length >= Constants.MINIMUM_COLUMNS_FOR_SEASONAL_COLUMN ? (
                            <div className="top-categories__list-headline--seasonal">
                                {texts.footer_seasonal_headline}
                            </div>
                        ) : (
                            <></>
                        )}

                        {renderColumns(topCategories.left)}
                        {renderColumns(topCategories.right)}
                    </div>
                </div>
            </>
        );
    }
    return <></>;

    function renderColumns(data) {
        return (
            <div className="top-categories__list-column">
                {data.columns.map((column, index) => {
                    return renderCategories(column.categories, index);
                })}
            </div>
        );
    }

    function renderCategories(categories, index) {
        return (
            <div key={index} className="top-categories__list-block">
                {categories.map((category, index) => {
                    return (
                        <a
                            key={index}
                            href={category.url}
                            className="top-categories__list-item"
                            jsh-landmark=""
                            jsh-landmark__click={category.landmark ? category.landmark : ''}
                        >
                            {category.name}
                        </a>
                    );
                })}
            </div>
        );
    }

    function update(modelJson) {
        if (modelJson) {
            setTopCategories(modelJson.topCategoriesModel);
        }
    }
}
